import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="bg-brand-cocoa pb-16" data-id="element-77" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-78" data-mp="3ggkal1dq1o2p">
        <p className="text-[0.68rem] leading-snug text-white/65" data-id="element-79" data-mp="32p5mwh8vcypb">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[0.64rem] leading-snug text-white/65" data-id="element-80" data-mp="36nd4feb5q41k">
          {PRODUCT_NAME}™ es un producto educativo. No sustituye formación
          profesional, capacitación en manipulación de alimentos, habilitaciones
          comerciales, normas sanitarias, requisitos de rotulado ni asesoramiento
          especializado. Toda elaboración y comercialización debe realizarse
          respetando las condiciones de higiene, conservación y seguridad
          alimentaria aplicables.
        </p>
        <p className="mt-1 text-[0.68rem] text-white/85" data-id="element-81" data-mp="2a19qldn7p8t2">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-brand-gold transition-colors duration-150 ease-out hover:text-white" data-id="element-82" data-mp="2ezl2rv0zbveg">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-[0.68rem] text-white/85" data-id="element-83" data-mp="3v7q6hr3xkngk">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-brand-gold" data-id="element-84" data-mp="3qapwj53yn0k6">
            Términos y Condiciones
          </a>
          <span className="text-white/40" data-id="element-85" data-mp="33noucq2vvnv">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-brand-gold" data-id="element-86" data-mp="htd4fcyx427o">
            Política de Privacidad
          </a>
          <span className="text-white/40" data-id="element-87" data-mp="qt049uc00zym">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-brand-gold" data-id="element-88" data-mp="qtrpqcbvthb6">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}